module.exports = __webpack_public_path__ + "img/upload-icon.faf29f67.png";